const UserCircleIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
    {...props}
  >
    <path
      d="M5.14835 16.3203C7.0719 15.2331 9.24455 14.6633 11.4541 14.6667C13.7458 14.6667 15.8972 15.2671 17.7599 16.3203M14.2041 9.16667C14.2041 9.89601 13.9144 10.5955 13.3986 11.1112C12.8829 11.6269 12.1834 11.9167 11.4541 11.9167C10.7248 11.9167 10.0253 11.6269 9.50956 11.1112C8.99383 10.5955 8.7041 9.89601 8.7041 9.16667C8.7041 8.43732 8.99383 7.73785 9.50956 7.22212C10.0253 6.7064 10.7248 6.41667 11.4541 6.41667C12.1834 6.41667 12.8829 6.7064 13.3986 7.22212C13.9144 7.73785 14.2041 8.43732 14.2041 9.16667ZM19.7041 11C19.7041 12.0834 19.4907 13.1562 19.0761 14.1571C18.6615 15.1581 18.0538 16.0675 17.2877 16.8336C16.5216 17.5997 15.6122 18.2074 14.6112 18.622C13.6103 19.0366 12.5375 19.25 11.4541 19.25C10.3707 19.25 9.2979 19.0366 8.29696 18.622C7.29603 18.2074 6.38655 17.5997 5.62047 16.8336C4.85439 16.0675 4.2467 15.1581 3.8321 14.1571C3.41749 13.1562 3.2041 12.0834 3.2041 11C3.2041 8.81196 4.0733 6.71354 5.62047 5.16637C7.16765 3.61919 9.26607 2.75 11.4541 2.75C13.6421 2.75 15.7406 3.61919 17.2877 5.16637C18.8349 6.71354 19.7041 8.81196 19.7041 11Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export default UserCircleIcon;
